import { ImageHashPreview } from 'dy-frontend-shared/lib/data/valueObjects';

const imageHashPreview = new ImageHashPreview(process.env.HASH_IMAGE_STORE_BASE_URL ?? process.env.API_BASE_URL ?? '');

export default imageHashPreview;
